/* eslint-disable no-underscore-dangle */
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');


const CheckEmailVerificationStatus = (username) => {
  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };
  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
    Username: username,
  });

  const userData = {
    Username: username,
    Pool: userPool,
  };
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line func-names
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess(result) {
        return resolve(result);
      },
      onFailure(err) {
        // eslint-disable-next-line no-console
        return reject(err);
      },
    });
  });
};

export { CheckEmailVerificationStatus as default };
